import { Module } from 'wrapper6';
import {Panel, Audio} from '../../../audioplayer';
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";
import { debounce } from "../utils/_debounce";

export default class AudioPlayer extends Module {

	ready(app) {

        new MTTAudioPlayer();

	}
}

class MTTAudioPlayer {

    constructor() {

        // elements
        this.AUDIO_BUTTON = document.getElementById('audio-button-link');
        this.MINIMIZE_AUDIO_BUTTON = document.getElementById('minimize-audio-player');
        this.CLOSE_AUDIO_BUTTON = document.getElementById('close-audio-player');
        this.PLAYER_CONTAINER = document.querySelector('.mtt-audio-player');
        this.PLAY_BUTTONS = document.querySelectorAll('.open-audio-player');

        if (!this.AUDIO_BUTTON && !this.PLAYER_CONTAINER)
            return;

        // audio panel + player controls
        this.audio = new Audio();
        this.player = document.getElementById('player');
        this.panel = new Panel(this.player, this.audio);

        // book info
        this.info = {
            src: this.AUDIO_BUTTON.getAttribute('data-mp3'),
            title: this.AUDIO_BUTTON.getAttribute('data-title'),
            author: this.AUDIO_BUTTON.getAttribute('data-author')
        };

        // setup player
        this.setupAudioPlayer();

        // wrap player elements
        this.wrapTimeElements();
        this.addAuthor();

        // open audioplayer
        this.AUDIO_BUTTON.addEventListener('click', this.toggleAudioPlayer.bind(this));

        // close audioplayer
        this.MINIMIZE_AUDIO_BUTTON.addEventListener('click', this.minimizeButtonHandler.bind(this));

        // reset classes
        window.addEventListener('resize', debounce(() => this.resetClasses(), 200));

        // open audio player for audio buttons
        if (this.PLAY_BUTTONS) {
            for (let i = 0; i < this.PLAY_BUTTONS.length; i++) {
                this.PLAY_BUTTONS[i].addEventListener('click', this.toggleAudioPlayer.bind(this));
            }
        }
    }

    setupAudioPlayer() {

        // Set audio track
        this.panel.load({ 
            src: this.info.src,
            title: this.info.title,
            duration: "0:00"
        });
    }

    minimizeButtonHandler(e) {
        if (this.getPageWidth() > 1160) {
            this.toggleAudioPlayer(e);
        } else {
            this.minimizeAudioPlayer(e);
        }
    }

    toggleAudioPlayer(e) {
        e.preventDefault();
        this.resetClasses();

        toggleClass(this.PLAYER_CONTAINER, 'open-player');

        if (hasClass(this.PLAYER_CONTAINER, 'open-player')) {
            this.panel.play();
        } else {
            this.panel.pause();
        }
    }

    minimizeAudioPlayer(e) {
        e.preventDefault();
        toggleClass(this.PLAYER_CONTAINER, 'minimize');
    }

    resetClasses() {
        removeClass(this.PLAYER_CONTAINER, 'minimize');
    }

    wrapTimeElements() {

        // targets
        let targetElement = document.querySelector('.audiopanel-volume');
        let PlayTargetElement = document.querySelector('.audiopanel-time');

        // element that will be wrapped
        let elements = document.querySelectorAll('.audiopanel-time-current, .audiopanel-time-duration, .audiopanel-bar');
        let play_element = document.querySelector('.audiopanel-playpause');

        // the wrapper
        let wrapper = document.createElement('div');
        addClass(wrapper, 'time-container');

        // move elements into wrapper
        for (let i = 0; i < elements.length; i++) {
            const el = elements[i];
            wrapper.appendChild(el);
        }

        // the play wrapper
        let play_wrapper = document.createElement('div');
        addClass(play_wrapper, 'play-container');
        play_wrapper.appendChild(play_element);

        // append wrapper
        targetElement.parentNode.insertBefore(wrapper, targetElement);
        PlayTargetElement.parentNode.insertBefore(play_wrapper, PlayTargetElement);
    }

    addAuthor() {
        
        let targetElement = document.querySelector('.audiopanel-title-text');
        addClass(targetElement, 'box-orient-fix');

        // the author
        let author = document.createElement('div');
        addClass(author, 'author');
        addClass(author, 'box-orient-fix');
        author.innerHTML = this.info.author;

        // insert author after title
        targetElement.parentNode.insertBefore(author, targetElement.nextSibling);

    }

    getPageWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}